import { ga } from '../../../engine/ga-sidecar'
import { chessUiMessage } from './chessUiMessage-sidecar'

export function onCredits() {
  // \n\nAdditional Testing:
  ga.action('click', 'credits')
  let text = ''
  text += 'Designed and programmed by\n Stevie Bushman'
  text += '\n Keep Flying Games'
  text += '\n https://keepflyinggames.com'
  text += '\n\nAdditional sound effects from\n https://www.zapsplat.com'
  text += '\n\nChess pieces from https://joszs.itch.io/chess-pack'
  text +=
    '\n' +
    'Chess pieces under Creative Commons Attribution 4.0 International license'
  // text +=
  //   '\n\nAdditional sound effects licensed from\n https://cafofomusic.itch.io'
  // text +=
  //   "\n\nShip design inspired by\n Lazarus' Gabriel Fallen\n https://gm-lazarus.itch.io/gabriel-fallen"
  chessUiMessage.setText('Credits', text)
  chessUiMessage.setOpen(true)
}
